import ApiService from '@/common/api.service'

import { getField, updateField } from 'vuex-map-fields';

/* eslint-disable */
const getDefaultState = () => {
  return {
    presetIndividualForm: {
      id: 0,
      isActive: true,
      sampleID: null,
      date: null,
      name: null,
      mtDNA: null,
      yDNATM: null,
      yDNAISOGG: null,
      location: null,
      g25Coordinate: null,
      latitude: null,
      longitude: null,
      research: null,
      researchLink: null,
    },
  }
}

const state = getDefaultState()

const getters = {
  getAncientField(state) {
    return getField(state.presetIndividualForm);
  },
  getAncientForm(state) {
    return state.presetIndividualForm;
  },
}

const mutations = { 
  updateAncientField(state, field) {
    updateField(state.presetIndividualForm, field);
  },
  setAncientField(state, data) {
    state.presetIndividualForm = data;
  },
  resetAncientField(state) {
    Object.assign(state, getDefaultState())
  },
}

const actions = {
  fetchPresetIndividuals(ctx, queryParams) {
    return new Promise((resolve, reject) => {
      ApiService.get('PresetIndividualSample/pagination', queryParams, this)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  },

  fetchPresetIndividual(context, queryParams) {
    return new Promise((resolve, reject) => {
      ApiService.get(`PresetIndividualSample/${queryParams.id}`, queryParams, this)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  },

  savePresetIndividual(ctx, queryParams) {
    return new Promise((resolve, reject) => {
      ApiService.post('PresetIndividualSample', queryParams, this)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  },

  removePresetIndividual(context, queryParams) {
    return new Promise((resolve, reject) => {
      ApiService.get(`PresetIndividualSample/delete/${queryParams.id}`, {}, this)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
